import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      position="top-right"
      expand={false}
      richColors
      closeButton
      toastOptions={{
        style: {
          background: 'rgba(109, 90, 137, 0.95)',
          border: '1px solid rgba(9, 166, 163, 0.3)',
          color: 'white',
        },
        className: 'toaster-custom',
      }}
      {...props} 
    />
  );
}

export { Toaster }
